import Configs from "../../vendorConfigs/Configs";
import BetModel from "../../../core/src/model/BetModel";
import GameModel from "../../../core/src/model/GameModel";
import SpinModel from "../../../core/src/model/SpinModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";

export default class FreeSpinRequest implements IRequestBuilder {

    get method() {
        return "POST";
    }
    
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/play";
    }
    
    get requestData() {

        GameModel.incrementRestoreVersion();
        let lastRestoreVersion = GameModel.restoreVersion;
        let index =
          SpinModel.currentGeneration && SpinModel.generations
            ? SpinModel.generations[SpinModel.currentGeneration].index
            : 0;
        let state = JSON.stringify({
          generation: index,
          roundFinished: SpinModel.roundFinish,
          restoreVersion: GameModel.restoreVersion,
        });
       
        return {
            sid: GameModel.sessionID,
            g: Configs.vendorServer.gameId,
            ga: "select",
            option: SpinModel.featureMode,
            ba: BetModel.totalBet,
            restoreState: state,
            restoreVersion: lastRestoreVersion
        };
        
    }
}
